import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'

export default function RouteProgressBar() {
  const location = useLocation()
  const [active, setActive] = useState(false)
  const [key, setKey] = useState(0)

  useEffect(() => {
    setActive(true)
    setKey(k => k + 1)
    const t = setTimeout(() => setActive(false), 700)
    return () => clearTimeout(t)
  }, [location.pathname])

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          key={key}
          initial={{ scaleX: 0, opacity: 1 }}
          animate={{ scaleX: 1, opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, height: 2,
            background: 'linear-gradient(90deg, #06b6d4, #22d3ee, #67e8f9)',
            transformOrigin: 'left center',
            zIndex: 99998,
            pointerEvents: 'none',
            boxShadow: '0 0 16px rgba(6,182,212,0.9), 0 0 4px rgba(6,182,212,1)',
          }}
        />
      )}
    </AnimatePresence>
  )
}
